import { requests } from "../../../../api/agent"

export default {
	create          : (params) => requests.post('/reRegion/create', params),
	update          : (params) => requests.post('/reRegion/update', params),
	delete          : (params) => requests.getWithParams('/reRegion/delete', params),
	restore         : (params) => requests.getWithParams('/reRegion/restore', params),
	getPaged        : (params) => requests.getWithParams('/reRegion/getPaged', params),
	getPagedAll     : (params) => requests.getWithParams('/reRegion/getPagedAll', params),
	getList         : (params) => requests.getWithParams('/reRegion/getList', params),
	getListForRoles : (params) => requests.getWithParams('/reRegion/getListForRoles', params),
	getPagedAudit   : (params) => requests.getWithParams('/reRegion/getPagedAudit', params)
}